exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider_wrapper[data-v-dd07957e] {\n  position: relative;\n  z-index: 0;\n}\n.slider_wrapper .dots[data-v-dd07957e] {\n  position: absolute;\n  z-index: 999;\n  bottom: 1em;\n  left: 0;\n  right: 0;\n  text-align: center;\n}\n.slider_wrapper .dots .dot[data-v-dd07957e] {\n  display: inline-block;\n  background: #c92222;\n  border-radius: 1em;\n  width: 1em;\n  height: 1em;\n  margin: 0 0.1em;\n}\n.slider_wrapper .dots .dot.active[data-v-dd07957e] {\n  background: #ffffff;\n}\n.slider_wrapper .dots .dot a[data-v-dd07957e] {\n  display: block;\n  width: 1em;\n  height: 1em;\n}\n", ""]);

// exports
